import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Profile from "../../assets/images/fds.png";
import Sprofile from "../../assets/images/profile.png";
import Sbell from "../../assets/images/sbell.png";
import Userview from "../../assets/images/useer_view.png";
// import Saccount from "../../assets/images/account-settings.png";
import Smanagement from "../../assets/images/management.png";
import Filter from "../../assets/images/uldsetting.png";
import Acsetting from "../../assets/images/account-settings.png";
import Uprofile from "../../assets/images/profile.png";
import Rsetting from "../../assets/images/rsettings.png";
import Nsetting from "../../assets/images/sbell.png";
import Offline from "../../assets/images/offline.png";
import Shipment from "../../assets/images/shipment.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';


import {
    useAuth, useAuthRFS, useAuthULD, useAuthASR, useAuthHSR, useAuthAirline, useAuthHSPL,
    useAuthFULD, useAuthFSHP, useAuthForwarder, useAuthHandler, useAuthHULD, useAuthFDVR,
    useAuthDVR, useAuthTrucking
} from '../../useAuth/useAuth';

export const LeftSettings = ({ mode, onTab, selectedTab }) => {
    const isAuthenticated = useAuth();
    const isAuthenticatedAirline = useAuthAirline();
    const isAuthenticatedHandler = useAuthHandler();
    const isAuthenticatedRFS = useAuthRFS();
    const isAuthenticatedULD = useAuthULD();
    const isAuthenticatedASR = useAuthASR();
    const isAuthenticatedHSR = useAuthHSR();
    const isAuthenticatedHSPL = useAuthHSPL();
    const isAuthenticatedFULD = useAuthFULD();
    const isAuthenticatedFSM = useAuthFSHP();
    const isAuthenticatedHULD = useAuthHULD();
    const isAuthenticatedFDVR = useAuthFDVR();
    const isAuthenticatedDVR = useAuthDVR();
    const isAuthenticatedTRK = useAuthTrucking();
    const isAuthenticatedForwarder = useAuthForwarder();
    const location = useLocation();
    const navItems = [{ name: 'User Settings', path: '/AirlineSettings', image: Sprofile }]
    const navItemsDashboard = [
        { name: 'General Settings', path: '/AirlineSettings', image: Sprofile, tab: 'gen' },
        { name: 'User Settings', path: '/AirlineSettings', image: Sprofile, tab: 'user' },
        { name: 'Station Settings', path: '/StationSettings', image: Sprofile, tab: 'station' },
        { name: 'Template Management', path: '/TemplateManagementSettings', image: Offline, tab: 'template' },
        // { name: 'Region Settings', path: '/RegionSettings', image: Sprofile },
    ]
    const navItemsFDashboard = [
        { name: 'User Settings', path: '/UserSettings', image: Sprofile, tab: 'usr' },
        { name: 'Station Settings', path: '/StationSettings', image: Uprofile, tab: 'stn' },
        { name: 'Department Settings', path: '/DepartmentSettings', image: Uprofile, tab: 'dpt' },
        { name: 'Time Zone Settings', path: '/TimeZoneSettings', image: Uprofile, tab: 'tmz' },
        // { name: 'Driver Visitor Settings', path: '/DriverVisitorSettings', image: Uprofile, tab: 'dvs' },
        // { name: 'Station Settings', path: '/StationSettings', image: Sprofile },
        // { name: 'Region Settings', path: '/RegionSettings', image: Sprofile },
    ]
    const navItemsHAdmin = [
        { name: 'General Settings', path: '/GeneralSettings', image: Sprofile, tab: 'gen' },
        { name: 'User Settings', path: '/UserSettings', image: Sprofile, tab: 'usr' },
        { name: 'Station Settings', path: '/StationSettings', image: Sprofile, tab: 'stn' },
        { name: 'Warehouse Settings', path: '/WarehouseSettings', image: Sprofile, tab: 'wrh' },
        { name: 'Template Management', path: '/TemplateManagementSettings', image: Offline, tab: 'tmt' },
        { name: 'Time Zone Settings', path: '/TimeZoneSettings', image: Uprofile, tab: 'tmz' },
    ]
    const navItemsRFS = [
        { name: 'Notification Settings', path: '#', image: Sbell, tab: 'not' },
        // { name: 'Accessibility Settings', path: '#', image: Saccount  },
        // { name: 'Carrier Settings', path: '#', image: Smanagement  },
        { name: 'Trucker Settings', path: '#', image: Smanagement, tab: 'trk' },
        { name: 'Station Settings', path: '#', image: Smanagement, tab: 'stn' },
        { name: 'ULD Settings', path: '#', image: Smanagement, tab: 'uld' },
        { name: 'Region Settings', path: '#', image: Smanagement, tab: 'reg' },
        // { name: 'Security Settings', path: '/SecuritySettings', image: Rsettings  },
        // { name: 'Terms & Conditions', path: '/TermsnConditions', image: Contract  },
        // Add more items with respective paths as needed
    ];
    const navItemsULD = [
        { name: 'General Settings', path: '/GeneralSettings', image: Rsetting, tab: 'gen' },
        { name: 'Region Settings', path: '/RegionSettings', image: Uprofile, tab: 'reg' },
        { name: 'Access Rights Settings', path: '/AccessRightsSettings', image: Acsetting, tab: 'ars' },
        { name: 'Notification Settings', path: '/NotificationSettings', image: Nsetting, tab: 'not' },
        { name: 'Inactive ULD Settings', path: '/InactiveUldSettings', image: Nsetting, tab: 'ina' },
        { name: 'Station Settings', path: '/StationSettings', image: Offline, tab: 'stn' },
        { name: 'Report Settings', path: '/ReportSettings', image: Smanagement, tab: 'rep' },
        { name: 'Message Settings', path: '/MessageSettings', image: Offline, tab: 'msg' }, // not live
        { name: 'Stock Allotment Settings', path: '/StockAllotmentSettings', image: Offline, tab: 'sas' }, // not live
    ];
    const navItemsASR = [
        { name: 'General Settings', path: '/GeneralSettings', image: Rsetting, tab: 'gen' },
        { name: 'Station Settings', path: '/RecoveryStationSettings', image: Offline, tab: 'stn' },
        // { name: 'Template Management', path: '/TemplateManagementSettings', image: Offline },
        { name: 'File Management', path: '/FileManagementSettings', image: Offline, tab: 'fms' },
        { name: 'Addressbook Settings', path: '#', image: Offline, tab: 'abs' },
        // { name: 'User Settings', path: '/UserSettings', image: Offline },
        // { name: 'Department Settings', path: '/DepartmentSettings', image: Offline },
        { name: 'Department Settings', path: '/UserDepartmentSettings', image: Offline, tab: 'dps' },
        // { name: 'Region Settings', path: '/RegionSettings', image: Uprofile },
        // { name: 'Access Rights Settings', path: '/AccessRightsSettings', image: Acsetting },
        // { name: 'Notification Settings', path: '/NotificationSettings', image: Nsetting },
        // { name: 'Station Settings', path: '/RecoveryStationSettings', image: Offline },
        // { name: 'Report Settings', path: '/ReportSettings', image: Smanagement },
    ];
    const navItemsHSR = [
        { name: 'General Settings', path: '/GeneralSettings', image: Rsetting, tab: 'gen' },
        // { name: 'Region Settings', path: '/RegionSettings', image: Uprofile },
        // { name: 'Access Rights Settings', path: '/AccessRightsSettings', image: Acsetting },
        // { name: 'Notification Settings', path: '/NotificationSettings', image: Nsetting },
        { name: 'Addressbook Settings', path: '#', image: Offline, tab: 'ads' },
        { name: 'Station Settings', path: '/RecoveryStationSettings', image: Offline, tab: 'stn' },
        // { name: 'Report Settings', path: '/ReportSettings', image: Smanagement },
    ];
    const navItemsSPL = [
        { name: 'Door Configuration', path: '/DoorConfiguration', image: Uprofile, tab: 'drc' },
        // { name: 'Doors Availability', path: '/DoorsAvailability', image: Uprofile },
        { name: 'Slot Settings', path: '/SlotSettings', image: Uprofile, tab: 'slt' },
        { name: 'Trucker Settings', path: '/TruckerSettings', image: Uprofile, tab: 'trs' },
        { name: 'Airline Settings', path: '/AirlineSettings', image: Uprofile, tab: 'ars' },
        { name: 'Resource Settings', path: '/ResourceSettings', image: Uprofile, tab: 'rss' },
    ]
    const navItemsFULD = [
        { name: 'General Settings', path: '/GeneralSettings', image: Rsetting, tab: 'gen' },
        // { name: 'User Settings', path: '/UserSettings', image: Rsetting },
        // { name: 'Station Settings', path: '/StationSettings', image: Uprofile },
        // { name: 'Department Settings', path: '/DepartmentSettings', image: Uprofile },
    ]
    const navItemsDVR = [
        { name: 'Device Settings', path: '/DeviceSettings', image: Rsetting, tab: 'gen' },
    ]
    const navItemsTRK = [
        { name: 'User Settings', path: '#', image: Rsetting, tab: 'usr' },
    ]
    const navItemsHULD = [
        { name: 'Airline Settings', path: '/GeneralSettings', image: Rsetting, tab: 'air' },
        { name: 'Agent Settings', path: '/GeneralSettings', image: Rsetting, tab: 'agt' },
        { name: 'SCM Settings', path: '/SCMSettings', image: Rsetting, tab: 'scm' },
        // { name: 'Add Category Invoice', path: '/AddCategoryInvoice', image: Rsetting },
        // { name: 'Customer Settings', path: '/CustomerSettings', image: Rsetting },
    ]
    const navItemsFSM = [
        { name: 'General Settings', path: '/GeneralSettings', image: Rsetting, tab: 'gen' },
        { name: 'Shipment Record Settings', path: '/ShipmentRecordSettings', image: Rsetting, tab: 'srs' },
        { name: 'Add Category Invoice', path: '/AddCategoryInvoice', image: Rsetting, tab: 'aci' },
        { name: 'Customer Settings', path: '/CustomerSettings', image: Rsetting, tab: 'crs' },
        { name: 'Location Settings', path: '/LocationSettings', image: Rsetting, tab: 'loc' },
        { name: 'Quotation Settings', path: '/QuotationSettings', image: Rsetting, tab: 'qut' },
        { name: 'Quotation Org Settings', path: '/QuotationOrgSettings', image: Rsetting, tab: 'quto' },
        { name: 'Station Rates', path: '/StationRates', image: Rsetting, tab: 'str' },
        // { name: 'Airfreight Rates', path: '/AirfreightRates', image: Rsetting },
        // { name: 'Department Settings', path: '/DoorsAvailability', image: Uprofile },
    ]

    //   const navItemsForAuth = navItems.filter(item => item.path == '/UserSettings');

    //   const navItemsForRFS = navItems.filter(item => item.path !== '/UserSettings');

    const linksClick = (e, path) => {
        e.preventDefault();

        window.location.replace(path);
    }

    const linksTab = (e, path) => {
        e.preventDefault();
        onTab(path)
        // window.location.replace(path);
    }

    return (
        <>
            {/* {console.log('aaaaaaaa')        } */}
            <div className='col-3 col-xxl-3 stting_left'>
                <div className='settingbg'>
                    {isAuthenticated &&
                        <div className='profile'>
                            <img src={Profile} />
                            <h3>Free Account</h3>
                            <p>Settings</p>
                        </div>
                    }
                    {isAuthenticatedAirline &&
                        <div className='profile'>
                            <img src={Profile} />
                            <h3>General Settings</h3>
                            <p>Airline Settings</p>
                        </div>
                    }
                    {isAuthenticatedForwarder &&
                        <div className='profile'>
                            <img src={Profile} />
                            <h3>General Settings</h3>
                            <p>Forwarder Settings</p>
                        </div>
                    }
                    {isAuthenticatedRFS &&
                        <div className='profile'>
                            <img src={Profile} />
                            <h3>RFS Control Tower</h3>
                            <p>Module Settings</p>
                        </div>
                    }
                    {isAuthenticatedULD &&
                        <>
                            {/* <div className='main_setting'> <Link to="/UserSettings"><FontAwesomeIcon icon={faGear} /> Org Settings</Link>  </div> */}
                            <div className='profile mt-4'>
                                <img src={Filter} />
                                <h3> ULD Control</h3>
                                <p>Module Settings</p>
                            </div>
                        </>
                    }
                    {isAuthenticatedASR &&
                        <>
                            {/* <div className='main_setting'> <Link to="/UserSettings"><FontAwesomeIcon icon={faGear} /> Org Settings</Link>  </div> */}
                            <div className='profile mt-4'>
                                <img src={Filter} />
                                <h3> Service Recovery</h3>
                                <p>Module Settings</p>
                            </div>
                        </>
                    }
                    {isAuthenticatedHSR &&
                        <>
                            {/* <div className='main_setting'> <Link to="/UserSettings"><FontAwesomeIcon icon={faGear} /> Org Settings</Link>  </div> */}
                            <div className='profile mt-4'>
                                <img src={Filter} />
                                <h3> Service Recovery</h3>
                                <p>Module Settings</p>
                            </div>
                        </>
                    }
                    {isAuthenticatedHSPL &&
                        <>
                            <div className='profile mt-4'>
                                <img src={Shipment} />
                                <h3>Slot Planning</h3>
                                <p>Module Settings</p>
                            </div>
                        </>
                    }
                    {isAuthenticatedFULD &&
                        <>
                            <div className='profile mt-4'>
                                <img src={Shipment} />
                                <h3>Forwarder ULD Settings</h3>
                                <p>Module Settings</p>
                            </div>
                        </>
                    }
                    {isAuthenticatedFSM &&
                        <>
                            <div className='profile mt-4'>
                                <img src={Shipment} />
                                <h3>Shipment Manager</h3>
                                <p>Module Settings</p>
                            </div>
                        </>
                    }
                    {isAuthenticatedHandler && mode == 'HSA' &&
                        <>
                            <div className='profile mt-4'>
                                <img src={Shipment} />
                                <h3>Handler Settings</h3>
                                <p>Module Settings</p>
                            </div>
                        </>
                    }
                    {isAuthenticatedHULD &&
                        <>
                            <div className='profile mt-4'>
                                <img src={Shipment} />
                                <h3>Handler ULD Settings</h3>
                                <p>Module Settings</p>
                            </div>
                        </>
                    }
                    {isAuthenticatedDVR &&
                        <>
                            <div className='profile mt-4'>
                                <img src={Shipment} />
                                <h3>Driver Visitor Settings</h3>
                                <p>Module Settings</p>
                            </div>
                        </>
                    }
                    {isAuthenticatedTRK &&
                        <>
                            <div className='profile mt-4'>
                                <img src={Shipment} />
                                <h3>Trucker Settings</h3>
                                <p>Module Settings</p>
                            </div>
                        </>
                    }
                    <ul>
                        {isAuthenticated && navItems.map(item => (
                            <li key={item.path} className={`${location.pathname === item.path ? 'active' : ''}`}>
                                <Link to='#' onClick={(e) => linksClick(e, item.path)}>
                                    <img src={item.image} alt={item.name} />
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        {isAuthenticatedAirline && navItemsDashboard.map(item => (
                            // <li key={item.path} className={`${location.pathname === item.path ? 'active' : ''}`}>
                            <li key={item.path} className={`${selectedTab === item.tab ? 'active' : ''}`}>
                                <Link to='#' onClick={(e) => linksTab(e, item.tab)}>
                                    <img src={item.image} alt={item.name} />
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        {isAuthenticatedForwarder && navItemsFDashboard.map(item => (
                            // <li key={item.path} className={`${location.pathname === item.path ? 'active' : ''}`}>
                            //     <Link to='#' onClick={(e) => linksClick(e, item.path)}>
                            //         <img src={item.image} alt={item.name} />
                            //         {item.name}
                            //     </Link>
                            // </li>
                            <li key={item.path} className={`${selectedTab === item.tab ? 'active' : ''}`}>
                                <Link to='#' onClick={(e) => linksTab(e, item.tab)}>
                                    <img src={item.image} alt={item.name} />
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        {isAuthenticatedHandler && mode == 'HSA' && navItemsHAdmin.map(item => (
                            // <li key={item.path} className={`${location.pathname === item.path ? 'active' : ''}`}>
                            //     <Link to='#' onClick={(e) => linksClick(e, item.path)}>
                            //         <img src={item.image} alt={item.name} />
                            //         {item.name}
                            //     </Link>
                            // </li>
                            <li key={item.path} className={`${selectedTab === item.tab ? 'active' : ''}`}>
                                <Link to='#' onClick={(e) => linksTab(e, item.tab)}>
                                    <img src={item.image} alt={item.name} />
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        {isAuthenticatedRFS && navItemsRFS.map(item => (
                            // <li key={item.path} className={`${location.pathname === item.path ? 'active' : ''}`}>
                            //     <Link to='#' onClick={(e) => linksClick(e, item.path)}>
                            //         <img src={item.image} alt={item.name} />
                            //         {item.name}
                            //     </Link>
                            // </li>
                            <li key={item.path} className={`${selectedTab === item.tab ? 'active' : ''}`}>
                                <Link to='#' onClick={(e) => linksTab(e, item.tab)}>
                                    <img src={item.image} alt={item.name} />
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        {isAuthenticatedULD && navItemsULD.map(item => (
                            // <li key={item.path} className={`${location.pathname === item.path ? 'active' : ''}`}>
                            //     <Link to='#' onClick={(e) => linksClick(e, item.path)}>
                            //         <img src={item.image} alt={item.name} />
                            //         {item.name}
                            //     </Link>
                            // </li>
                            <li key={item.path} className={`${selectedTab === item.tab ? 'active' : ''}`}>
                                <Link to='#' onClick={(e) => linksTab(e, item.tab)}>
                                    <img src={item.image} alt={item.name} />
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        {isAuthenticatedASR && navItemsASR.map(item => (
                            // <li key={item.path} className={`${location.pathname === item.path ? 'active' : ''}`}>
                            //     <Link to='#' onClick={(e) => linksClick(e, item.path)}>
                            //         <img src={item.image} alt={item.name} />
                            //         {item.name}
                            //     </Link>
                            // </li>
                            <li key={item.path} className={`${selectedTab === item.tab ? 'active' : ''}`}>
                                <Link to='#' onClick={(e) => linksTab(e, item.tab)}>
                                    <img src={item.image} alt={item.name} />
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        {isAuthenticatedHSR && navItemsHSR.map(item => (
                            // <li key={item.path} className={`${location.pathname === item.path ? 'active' : ''}`}>
                            //     <Link to='#' onClick={(e) => linksClick(e, item.path)}>
                            //         <img src={item.image} alt={item.name} />
                            //         {item.name}
                            //     </Link>
                            // </li>
                            <li key={item.path} className={`${selectedTab === item.tab ? 'active' : ''}`}>
                                <Link to='#' onClick={(e) => linksTab(e, item.tab)}>
                                    <img src={item.image} alt={item.name} />
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        {isAuthenticatedHSPL && navItemsSPL.map(item => (
                            // <li key={item.path} className={`${location.pathname === item.path ? 'active' : ''}`}>
                            //     <Link to='#' onClick={(e) => linksClick(e, item.path)}>
                            //         <img src={item.image} alt={item.name} />
                            //         {item.name}
                            //     </Link>
                            // </li>
                            <li key={item.path} className={`${selectedTab === item.tab ? 'active' : ''}`}>
                                <Link to='#' onClick={(e) => linksTab(e, item.tab)}>
                                    <img src={item.image} alt={item.name} />
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        {isAuthenticatedFULD && navItemsFULD.map(item => (
                            // <li key={item.path} className={`${location.pathname === item.path ? 'active' : ''}`}>
                            //     <Link to='#' onClick={(e) => linksClick(e, item.path)}>
                            //         <img src={item.image} alt={item.name} />
                            //         {item.name}
                            //     </Link>
                            // </li>
                            <li key={item.path} className={`${selectedTab === item.tab ? 'active' : ''}`}>
                                <Link to='#' onClick={(e) => linksTab(e, item.tab)}>
                                    <img src={item.image} alt={item.name} />
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        {isAuthenticatedDVR && navItemsDVR.map(item => (
                            // <li key={item.path} className={`${location.pathname === item.path ? 'active' : ''}`}>
                            //     <Link to='#' onClick={(e) => linksClick(e, item.path)}>
                            //         <img src={item.image} alt={item.name} />
                            //         {item.name}
                            //     </Link>
                            // </li>
                            <li key={item.path} className={`${selectedTab === item.tab ? 'active' : ''}`}>
                                <Link to='#' onClick={(e) => linksTab(e, item.tab)}>
                                    <img src={item.image} alt={item.name} />
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        {isAuthenticatedFSM && navItemsFSM.map(item => (
                            // <li key={item.path} className={`${location.pathname === item.path ? 'active' : ''}`}>
                            //     <Link to='#' onClick={(e) => linksClick(e, item.path)}>
                            //         <img src={item.image} alt={item.name} />
                            //         {item.name}
                            //     </Link>
                            // </li>
                            <li key={item.path} className={`${selectedTab === item.tab ? 'active' : ''}`}>
                                <Link to='#' onClick={(e) => linksTab(e, item.tab)}>
                                    <img src={item.image} alt={item.name} />
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        {isAuthenticatedTRK && navItemsTRK.map(item => (
                            <li key={item.path} className={`${selectedTab === item.tab ? 'active' : ''}`}>
                                <Link to='#' onClick={(e) => linksTab(e, item.tab)}>
                                    <img src={item.image} alt={item.name} />
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        {isAuthenticatedHULD && navItemsHULD.map(item => (
                            <li key={item.path} className={`${selectedTab === item.tab ? 'active' : ''}`}>
                                <Link to='#' onClick={(e) => linksTab(e, item.tab)}>
                                    <img src={item.image} alt={item.name} />
                                    {item.name}
                                </Link>
                            </li>
                        ))}
                        {/* {navItems.map((item) => (
                <li key={item.name}  className={`${location.pathname === item.path ? 'active' : ''}`}>
                    <Link to={item.path}>
                    <span><img src={item.image} /></span>{item.name}
                    </Link>
                </li>
            ))} */}
                        {/* <li className={selectedButton === 'user' ? 'active' : ''}>
                <Link to='/settings' onClick={() => handleButtonClick('user')}><span><img src={Sprofile} /></span> User Settings</Link >
            </li>
            <li className={selectedButton === 'notification' ? 'active' : ''}>
                <Link><span><img src={Sbell} /></span> Notification Settings</Link>
            </li>
            <li><Link><span><img src={Saccount} /></span> Accessibility Settings</Link></li>
            <li><Link><span><img src={Smanagement} /></span> Document Settings</Link></li>
            <li className={selectedButton === 'station' ? 'active' : ''}>
                <Link to='/settings'  onClick={() => handleButtonClick('station')}><span><img src={Smanagement} /></span> Station Settings</Link>
            </li>
            <li><Link><span><img src={Rsettings} /></span> Security Settings</Link></li>
            <li><Link><span><img src={Contract} /></span> Term & Conditions</Link></li> */}
                    </ul>
                </div>
            </div>
        </>
    )
}

export const LeftccountSettings = () => {
    const location = useLocation();
    const isAuthenticatedRFS = useAuthRFS();
    const isAuthenticatedULD = useAuthULD();
    const navItems = [
        { name: 'Manage Users', path: '/ManageUsers', image: Userview },
        { name: 'Accessibility Settings', path: '/AccessibilitySettings', image: Sbell },
        { name: 'User Specific Settings', path: '/UserSpecificSettings', image: Sprofile },
    ];
    const navItemsULD = [
        { name: 'User Settings', path: '/UserSettings', image: Userview },
        { name: 'Access Rights', path: '/AccessRights', image: Sbell },
    ];

    return (
        <>
            <div className='col-3 col-xxl-3 stting_left'>
                <div className='settingbg'>
                    <div className='profile'>
                        {isAuthenticatedRFS &&
                            <>
                                <img src={Profile} />
                                <h3> Account Setting</h3>
                                <p>Settings</p>
                            </>
                        }
                        {isAuthenticatedULD &&
                            <>
                                <img src={Profile} />
                                <h3> ULD Account Setting</h3>
                                <p>Settings</p>
                            </>
                        }
                    </div>
                    {isAuthenticatedRFS &&
                        <ul>
                            {navItems.map((item) => (
                                <li key={item.name} className={`${location.pathname === item.path ? 'active' : ''}`}>
                                    <Link to={item.path}>
                                        <span><img src={item.image} /></span>{item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    }
                    {isAuthenticatedULD &&
                        <ul>
                            {navItemsULD.map((item) => (
                                <li key={item.name} className={`${location.pathname === item.path ? 'active' : ''}`}>
                                    <Link to={item.path}>
                                        <span><img src={item.image} /></span>{item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    }
                </div>
            </div>
        </>
    )
}

// export  {LeftccountSettings};